var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"beforeClose":_vm.beforeClose,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.confirmDialog,"isdeling":_vm.isdeling}},[_c('p',{staticClass:"title"},[_vm._v("您确认要从回收站恢复以下账套："+_vm._s(_vm.rowData.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }